import React, { CSSProperties, useCallback, useEffect, useMemo, useState } from 'react';

import dayjs from 'dayjs';
import { Modal, Button, Table, Spin } from "antd";

import { File } from 'types/files';
import { HELPER } from 'utils/helper';
import UploadForm from './components/UploadForm';
import { getAllFiles } from 'services/files.service';

const UploadFiles: React.FC = () => {

  const [files, setFiles] = useState<File[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  
  const columnsData = useMemo(
    () => [
      {
        dataIndex: 'fileName',
        title: 'Nombre del archivo',
        key: 'fileName',
      },
      {
        dataIndex: 'uploadDate',
        title: 'Fecha de carga',
        key: 'uploadDate',
      },
      {
        dataIndex: 'month',
        title: 'Mes',
        key: 'month',
      },
      {
        dataIndex: 'year',
        title: 'Año',
        key: 'year',
      },
      {
        dataIndex: 'typeFile',
        title: 'Tipo de archivo',
        key: 'typeFile',
      },
    ],
    []
  );

  const fetchAllFiles = useCallback(async () => {
    try {
      setIsLoading(true);
      const resp = await getAllFiles();
      setFiles(resp.files);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
	}, []);

  const handleSuccessUpload = () => {
    setIsVisibleModal(false);
    fetchAllFiles();
  };
  
   useEffect(() => {
    fetchAllFiles();
   }, [])

	return (
		<>
      <Modal title="Carga de archivos" visible={isVisibleModal} onCancel={()=> setIsVisibleModal(false)} footer={false} maskClosable={false}>
        <UploadForm isSuccessUpload={handleSuccessUpload} />
      </Modal>
   
      <div>
        <div style={styles.topContainer}>
          <h1 style={styles.titleText}>Archivos cargados</h1>  
          <Button type="primary" onClick={()=> setIsVisibleModal(true)}>
            Importar archivo
          </Button>
        </div>

        <div>
          {isLoading ? (
            <div style={styles.loaderContainer}>
              <Spin />
            </div>
          ):(
          <Table
            bordered
            scroll={{ x: true }}
            dataSource={files
              ?.map((item, index) => ({
                ...item,
                key: `${index}_${Date.now()}`,
                fileName: item?.short_file_name,
                uploadDate: dayjs(item?.upload_date).format('DD/MM/YYYY'),
                month: HELPER.getMonthNameByString(item?.month) || '-',
                year: item?.year || '-',
                typeFile: item?.file_type,
              }))
              //@ts-expect-error
              .sort((a, b) => dayjs(b.upload_date, 'DD/MM/YYYY') - dayjs(a.upload_date, 'DD/MM/YYYY'))
            }
            pagination={{
              defaultCurrent: 1,
              pageSize: 15,
              total: files?.length,
              hideOnSinglePage: true,
            }}
            columns={columnsData}
          />
          )}
        </div>
      </div>
		</>
	);
};

const styles: { [key: string]: CSSProperties} = {
topContainer:{
  display:'flex', 
  flexDirection:'row', 
  alignItems:'center', 
  justifyContent:'space-between', 
  padding:12
},
titleText:{
  fontSize: "1.5rem", 
  margin:0
},
progressBarContainer:{
  marginTop:10, 
  marginBottom:10
},
loaderContainer:{
  display:'flex', 
  alignItems:'center', 
  justifyContent:'center'
}
}

export default React.memo(UploadFiles);
